import React, { useCallback, useState } from 'react';
import { FieldSet, KeyValue } from '../../../elements';
import formater from '../../common/formater';
import DocumentsView from '../../../enrollment/components/DocumentsView';
import { TTransferApplicationStepPageProps } from '../types';
import Axios from 'axios';
import { API_URL } from '../../../../lib/const';
import { toast } from 'react-toastify';

const TransferApplicationSummaryPage = ({ history, application, requestedDocuments, setApplication }: TTransferApplicationStepPageProps) => {
  const [loading, setLoading] = useState(false);

  const handleSubmitApplication = useCallback(async () => {
    setLoading(true);

    try {
      await Axios.post(`${API_URL}/transfers/applications/${application.token}/submit`, {});

      setApplication((value) => ({
        ...value,
        documentation_step_status: 'Em análise',
        personal_step_status: 'Em análise',
        status: 'Em análise',
      }))

      history.push(`/transferencias/aplicacao/${application.token}/aprovacao`);

    } catch {
      toast.error('Ocorreu um erro ao submter sua inscrição.')
    }

  }, [application])

  return (
    <>
      <FieldSet title="Dados Pessoais" />
      <div className="enrollment-flex">
        <KeyValue title={application.real_name} label="Nome" />
        <KeyValue title={application.assumed_name} label="Nome Social" />
        <KeyValue title={formater.cpf(application.cpf)} label="CPF" />
        <KeyValue title={application.email} label="Email" />
        <KeyValue title={formater.phone(application.phone)} label="Telefone" />
        <KeyValue title={application.birth_date} label="Data de nascimento" />
      </div>
      <FieldSet title="Processo" />
      <div className="enrollment-flex">
        <KeyValue title={application.process.name} label="Nome" />
        <KeyValue title={application.process.course.name} label="Curso" />
        <KeyValue title={`${application.desired_onboarding.field_step}ᵒ`} label="Período pleiteado" />
      </div>
      <FieldSet title="Documentações" />
      <div className="documents-base row">
        <DocumentsView
          personalDocumentsTypes={requestedDocuments}
          personalDocuments={application.documents}
        />
      </div>
      <div className="text-right mt-3">
        <div className="col-md-4 p-0 offset-md-8 col-sm-12">
          <div className="btn-actions">
            <button
              className="btn btn-black mr-2"
              onClick={() => history.push(`/transferencias/aplicacao/${application.token}/documentos`)}
            >
              Voltar
            </button>
            <button
              className="btn btn-primary"
              onClick={() => handleSubmitApplication()}
              disabled={loading}
            >
              {loading ? "Carregando..." : "Enviar"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default TransferApplicationSummaryPage;
